import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  title: {
    textAlign: 'center',
    marginTop: 100
  }
}))

function DemoPage(props) {
  const classes = useStyles()
  return (
    <h1 className={classes.title}>This is where users can try out your amazing SaaS tool!</h1>
  )
}

export default DemoPage
